var userAgent = require('../internals/engine-user-agent');

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-ios.js
// module id = 466
// module chunks = 0